import { toParameterClass } from 'app/model/adapters/linkedservices/parameter-config.util';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { Owned } from 'app/model/base/named';
import { CopySinkAdapter } from './copysink.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { RestResourceCopySink } from 'app/model/pipeline/copysink/rest-resource.copysink';
import { toParameterObject } from '../../linkedservices/parameter-config.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(RestResourceCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        httpRequestTimeout: '*',
        requestInterval: '*',
        requestMethod: '*',
        writeBatchSize: '*',
        additionalHeaders: '*',
        httpCompressionType: '*'
    }
})
export class RestResourceCopySinkAdapter extends CopySinkAdapter<RestResourceCopySink, Model.RestSink> {
    protected override async _toResource(copySink: RestResourceCopySink): Promise<Model.RestSink> {
        const result: Model.CopySink = CopySinkAdapter.getCommonCopySinkProperties(copySink, 'RestSink');
        result.httpRequestTimeout = ValueAdapter.toResource(copySink, RestResourceCopySink.REQUEST_TIMEOUT);

        result.requestInterval = ValueAdapter.toResource(copySink, RestResourceCopySink.REQUEST_INTERVAL);
        result.requestMethod = ValueAdapter.toResource(copySink, RestResourceCopySink.METHOD);
        result.writeBatchSize = ValueAdapter.toResource(copySink, RestResourceCopySink.WRITE_BATCH_SIZE);
        result.additionalHeaders = toParameterObject(copySink.additionalHeaders);
        result.httpCompressionType = ValueAdapter.toResource(copySink, RestResourceCopySink.HTTP_COMPRESSION_TYPE);
        return result;
    }

    protected override async _toModel(
        restSink: Model.RestSink,
        copyActivity: CopyActivity
    ): Promise<RestResourceCopySink> {
        const result = Owned.create<RestResourceCopySink>(Metamodel.modelFor(RestResourceCopySink), copyActivity);
        ValueAdapter.toModel(result, RestResourceCopySink.REQUEST_TIMEOUT, restSink.httpRequestTimeout);
        ValueAdapter.toModel(result, RestResourceCopySink.REQUEST_INTERVAL, restSink.requestInterval);
        ValueAdapter.toModel(result, RestResourceCopySink.METHOD, restSink.requestMethod);
        result.additionalHeaders = toParameterClass(restSink.additionalHeaders, result);
        ValueAdapter.toModel(result, RestResourceCopySink.WRITE_BATCH_SIZE, restSink.writeBatchSize);
        ValueAdapter.toModel(result, RestResourceCopySink.HTTP_COMPRESSION_TYPE, restSink.httpCompressionType);
        return result;
    }
}
